import { useEffect, useState } from 'react'
import { queryStringFrom, searchStateFrom } from 'lib/Refinement/Refinement'
import { SearchState } from 'react-instantsearch-core'
import { useDebouncedCallback } from 'use-debounce'

import useRouter from 'hooks/useRouter'

const UPDATE_URL_DEBOUNCE_TIME = 400

type UseSyncURLWithSearchReturn = {
  searchState: SearchState
  syncURL: (updatedSearchState: SearchState) => void
  areFiltersApplied: boolean
}

const useSyncURLWithSearch = (): UseSyncURLWithSearchReturn => {
  const router = useRouter()
  const [searchState, setSearchState] = useState<SearchState>(
    searchStateFrom(router.query),
  )

  useEffect(() => {
    const handleStart = (url: string) => {
      const queryString = url.split('?')[1]

      if (!queryString) {
        return
      }

      const params = Object.fromEntries(new URLSearchParams(queryString))

      if (queryStringFrom(searchState) !== `?${queryString}`) {
        setSearchState(searchStateFrom(params))
      }
    }

    router.events.on('routeChangeStart', handleStart)

    return () => {
      router.events.off('routeChangeStart', handleStart)
    }
  }, [router, searchState])

  const [updateURL] = useDebouncedCallback(() => {
    router.push(`/search${queryStringFrom(searchState)}`, undefined, {
      scroll: false,
    })
  }, UPDATE_URL_DEBOUNCE_TIME)

  useEffect(updateURL, [searchState, updateURL])

  return {
    searchState,
    syncURL: setSearchState,
    areFiltersApplied: !!queryStringFrom(searchState),
  }
}

export default useSyncURLWithSearch
